@let neutralColorValue = neutralColor();
<mat-drawer-container autosize>
  <div class="base-container">
    <a id="start"></a>
    <form>
      @let stationListValue = stationList();
      @let archiveStationListValue = archiveStationList();
      @let selectedStationInfoValue = selectedStationInfo();
      @let archiveOnlyValue = archiveOnly();
      @let selectedStationValue = selectedStation();
      @let selectedArchiveStationValue = selectedArchiveStation();
      @if (archiveStationListValue.length > 0) {
        @let webcamStatusValue = webcamStatus();
        @let selectedIndexValue = actualSelectedIndex();
        <mat-tab-group
          class="mat-tab-group--smw"
          #tabControl
          dynamicHeight
          (selectedTabChange)="onTabChanged($event)"
          [selectedIndex]="selectedIndexValue">
          <!-- Overview Cards-->
          @let smwStationsValue = smwStations();
          @let latestSmwDataValue = latestSmwData();
          @let countOfDisplayedOverviewCardsValue =
            countOfDisplayedOverviewCards();
          @let latestWebcamImagesValue = latestWebcamImages();
          <mat-tab [disabled]="archiveOnlyValue">
            <ng-template mat-tab-label>
              <fa-icon
                [icon]="['far', 'grip-horizontal']"
                class="tab-icon"
                size="lg"></fa-icon>
              &nbsp;
              {{ 'PRODUCT.SMW.Overview' | translate }}
            </ng-template>
            <div class="basic-margin-wrapper--top-bottom">
              <div class="flex-flow-wrapper" #cardContainer>
                @if (
                  smwStationsValue.length > 0 &&
                  smwStationsValue.length === archiveStationListValue.length &&
                  latestSmwDataValue
                ) {
                  @let minCardHeightValue = minCardHeight();
                  @let overviewStationListValue = overviewStationList();
                  @for (
                    station of overviewStationListValue;
                    track $index;
                    let i = $index
                  ) {
                    @if (
                      i < countOfDisplayedOverviewCardsValue - 1 &&
                      latestSmwDataValue.hasOwnProperty(station.stationId) &&
                      (latestSmwDataValue[station.stationId].hasOwnProperty(
                        'tt'
                      ) ||
                        latestSmwDataValue[station.stationId].hasOwnProperty(
                          'road_tt'
                        ) ||
                        latestSmwDataValue[station.stationId].hasOwnProperty(
                          'ff'
                        ) ||
                        latestSmwDataValue[station.stationId].hasOwnProperty(
                          'rrr'
                        ) ||
                        (latestSmwDataValue[station.stationId] | key).length ===
                          0)
                    ) {
                      <mat-card
                        appearance="outlined"
                        [ngStyle]="{ minHeight: minCardHeightValue + 'px' }"
                        class="station-card"
                        (click)="onStationCardClick(station.stationId)">
                        <app-smw-overview-card
                          [station]="station"
                          [latestSmwData]="
                            latestSmwDataValue[station.stationId]
                          "
                          [webcamStatus]="
                            webcamStatusValue[station.stationId] || false
                          "
                          [webcamImage]="
                            latestWebcamImagesValue[station.stationId]
                          "
                          [stationInfos]="
                            smwStationsValue
                          "></app-smw-overview-card>
                      </mat-card>
                    }
                  }
                  @if (
                    countOfDisplayedOverviewCardsValue < stationListValue.length
                  ) {
                    @let addedDisplayedOverviewCardsValue =
                      addedDisplayedOverviewCards();
                    <mat-card
                      appearance="outlined"
                      class="station-card station-card-placeholder"
                      (click)="
                        addedDisplayedOverviewCards.set(
                          addedDisplayedOverviewCardsValue + 1
                        )
                      ">
                      <div class="station-card-placeholder-content">
                        <div class="station-card-placeholder-icon">
                          <fa-icon [icon]="['far', 'plus']" size="lg"></fa-icon>
                        </div>
                        <h3>
                          {{ 'PRODUCT.SMW.SHOW_MORE_STATIONS' | translate }}
                        </h3>
                        <p class="mat-body-small">
                          Weitere Messstationen im aktuellen Gebiet laden
                        </p>
                      </div>
                    </mat-card>
                  }
                }
              </div>
            </div>

            <ng-container *ngTemplateOutlet="legend"></ng-container>
          </mat-tab>

          <!-- Overview Map -->
          <mat-tab [disabled]="archiveOnlyValue">
            <ng-template mat-tab-label>
              <fa-icon
                [icon]="['far', 'globe-africa']"
                class="tab-icon"
                size="lg"></fa-icon>
              &nbsp;
              {{ 'PRODUCT.SMW.MAP' | translate }}
            </ng-template>
            @if (
              smwStationsValue.length > 0 &&
              smwStationsValue.length === archiveStationListValue.length &&
              latestSmwDataValue &&
              webcamsWereChecked()
            ) {
              @if (showMap()) {
                @let isTabVisible = selectedIndexValue === MAP_TAB_INDEX;
                <mat-card appearance="outlined" class="smw-map-card">
                  <app-smw-overview-map
                    [stations]="smwStationsValue"
                    [latestSmwData]="latestSmwDataValue"
                    [webcamImages]="latestWebcamImagesValue"
                    [webcamAvailable]="webcamAvailable()"
                    [isVisible]="isTabVisible"
                    (navigateToStationView)="
                      onNavigateToStationView($event)
                    "></app-smw-overview-map>
                </mat-card>
              }
            }

            <!-- <ng-container *ngTemplateOutlet="legend"></ng-container> -->
          </mat-tab>

          <!-- Table -->
          @let smwDataValue = smwData();
          <mat-tab [disabled]="archiveOnlyValue">
            <ng-template mat-tab-label>
              <fa-icon
                [icon]="['far', 'th']"
                class="tab-icon"
                size="lg"></fa-icon>
              &nbsp;
              {{ 'PRODUCT.SMW.TABLE' | translate }}
            </ng-template>
            @if (stationListValue.length > 0) {
              <ng-container
                *ngTemplateOutlet="
                  stationSelect;
                  context: { $implicit: 'table' }
                "></ng-container>
              @if (selectedStationInfoValue && smwDataValue) {
                <app-smw-table
                  [smwData]="smwDataValue"
                  [station]="selectedStationValue"
                  [webcamStatus]="webcamStatusValue[selectedStationValue]"
                  [stationInfo]="selectedStationInfoValue">
                </app-smw-table>
              }
            }

            <ng-container *ngTemplateOutlet="legend"></ng-container>
          </mat-tab>

          <!-- Meteogram -->
          <mat-tab [disabled]="archiveOnlyValue">
            <ng-template mat-tab-label>
              <fa-icon
                [icon]="['far', 'analytics']"
                class="tab-icon"
                size="lg"></fa-icon>
              &nbsp;
              {{ 'PRODUCT.SMW.METEOGRAM' | translate }}
            </ng-template>
            <ng-container
              *ngTemplateOutlet="
                stationSelect;
                context: { $implicit: 'meteogram' }
              "></ng-container>
            @if (smwDataValue && showMeteogram()) {
              <app-smw-meteogram
                [smwData]="smwDataValue"
                [station]="selectedStationInfoValue">
              </app-smw-meteogram>
            }
          </mat-tab>

          <!-- Archive -->
          <mat-tab>
            <ng-template mat-tab-label>
              <fa-icon
                [icon]="['far', 'archive']"
                class="tab-icon"
                size="lg"></fa-icon>
              &nbsp;
              {{ 'PRODUCT.SMW.TAB_ARCHIVE' | translate }}
            </ng-template>
            <ng-container
              *ngTemplateOutlet="
                stationSelect;
                context: { $implicit: 'archive' }
              "></ng-container>
            @if (selectedStationInfoValue) {
              <app-smw-archive
                [stationId]="selectedArchiveStationValue"
                [stationInfo]="selectedStationInfoValue">
              </app-smw-archive>
            }

            <ng-container *ngTemplateOutlet="legend"></ng-container>
          </mat-tab>
        </mat-tab-group>
      }
      &nbsp;
      <a id="cardsLegend"></a>
      <!-- Station Select -->
      <ng-template #stationSelect let-tab>
        <div class="panel">
          <!--GLOBAL STATION SEARCHBAR-->
          <app-global-station-search-bar
            (selectedStation)="
              onGlobalStationSelect(
                $event.id,
                $event.name,
                $event.nameOfSource,
                tab
              )
            "
            [sourceIdNotToInclude]="2"
            [shouldTranslatedSourceIdBeAdded]="
              true
            "></app-global-station-search-bar>

          @if (!hasMoreThanFiveStations()) {
            <mat-form-field appearance="fill" class="station-select">
              <mat-label>{{
                'PRODUCT.SMW.stationenSearch' | translate
              }}</mat-label>

              <mat-select
                [formControl]="stationSelectControl[tab]"
                placeholder="{{ 'PRODUCT.SMW.stationenSearch' | translate }}">
                @if (tab !== 'archive') {
                  @for (station of stationListValue; track $index) {
                    <mat-option
                      [value]="station.stationId"
                      (onSelectionChange)="onStationChange($event, tab)">
                      {{ station.overwriteStationName }}
                    </mat-option>
                  }
                } @else {
                  @for (station of archiveStationListValue; track $index) {
                    <mat-option
                      [value]="station.stationId"
                      (onSelectionChange)="onStationChange($event, tab)">
                      {{ station.overwriteStationName }}
                    </mat-option>
                  }
                }
              </mat-select>
            </mat-form-field>
          } @else {
            <mat-form-field appearance="fill" class="station-select">
              <mat-label>{{
                'PRODUCT.SMW.stationenSearch' | translate
              }}</mat-label>
              <input
                type="text"
                matInput
                [formControl]="stationSelectControl[tab]"
                placeholder="{{ 'PRODUCT.SMW.stationenSearch' | translate }}"
                appResetInputMatAutocomplete
                [previousSelectedControlValue]="
                  tab === 'archive'
                    ? selectedArchiveStationValue
                    : selectedStationValue
                "
                [matAutocomplete]="stationsAutocomplete" />
              <mat-icon matSuffix>search</mat-icon>
              <mat-autocomplete
                #stationsAutocomplete="matAutocomplete"
                [displayWith]="displayStationName.bind(this)"
                (optionSelected)="onStationChange($event, tab)">
                @if (tab === 'table') {
                  @for (
                    station of tableStationListFilteredOptions$ | async;
                    track $index
                  ) {
                    <mat-option [value]="station.stationId">
                      {{ station.overwriteStationName }}
                    </mat-option>
                  }
                }
                @if (tab === 'meteogram') {
                  @for (
                    station of meteogramStationListFilteredOptions$ | async;
                    track $index
                  ) {
                    <mat-option [value]="station.stationId">
                      {{ station.overwriteStationName }}
                    </mat-option>
                  }
                }
                @if (tab === 'archive') {
                  @for (
                    station of archiveStationListFilteredOptions$ | async;
                    track $index
                  ) {
                    <mat-option [value]="station.stationId">
                      {{ station.overwriteStationName }}
                    </mat-option>
                  }
                }
              </mat-autocomplete>
            </mat-form-field>
          }

          @if (selectedStationInfoValue) {
            <span class="panel__text">{{
              'PRODUCT.SMW.STATION.TYPE.' + selectedStationInfoValue.type
                | translate
            }}</span>
            <span class="panel__text"
              >{{ selectedStationInfoValue.elevation }}m</span
            >
            <span class="panel__text"
              >[{{ selectedStationInfoValue.stationId }}]</span
            >
            @let hasUserEppValue =
              selectedStationInfoValue.stationId
                | hasUserEpp
                  : auth.isMaster()
                  : auth.getCustomerAlias()
                  : auth.getCustomerDocument()
                  : auth.hasUserWebAccess()
                  : auth.getUserProfile()?.['metadata']
                  : false;
            @if (hasUserEppValue) {
              <span class="panel__text">
                <button
                  mat-button
                  [routerLink]="['/epp', selectedStationInfoValue.stationId]">
                  <fa-icon [icon]="['far', 'external-link']"></fa-icon>&nbsp;
                  {{ 'PRODUCT.EPP.TITLE' | translate }}
                </button>
              </span>
            }
          }
        </div>
      </ng-template>

      <!-- Legende -->
      <ng-template #legend>
        <mat-card
          appearance="outlined"
          [@shake]="shakeAnimationState"
          class="legend-card">
          <button
            mat-icon-button
            class="up-button"
            (click)="onClickScrollToStart()">
            <fa-icon [icon]="['far', 'chevron-up']"></fa-icon>
          </button>
          <mat-card-header>
            <fa-icon
              mat-card-avatar
              [icon]="['far', 'info-circle']"
              size="lg"
              transform="right-2 down-2"></fa-icon>
            <mat-card-title>{{
              'PRODUCT.SMW.LEGENDE.TITLE' | translate
            }}</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div style="display: inline-block">
              <h3>
                <fa-icon [icon]="['far', 'thermometer-half']"></fa-icon>
                &nbsp; {{ 'PRODUCT.SMW.LEGENDE.tt' | translate }}
              </h3>
              <table cellpadding="3" class="legend-table" width="150">
                <tr>
                  <td width="25" class="smw-tt-0"></td>
                  <td><= 0°C</td>
                </tr>
                <tr>
                  <td width="25" class="smw-tt-1"></td>
                  <td><= 1°C</td>
                </tr>
                <tr>
                  <td width="25" class="smw-tt-3"></td>
                  <td><= 3°C</td>
                </tr>
                <tr>
                  <td
                    width="25"
                    [ngClass]="
                      neutralColorValue === 'green'
                        ? 'table-green'
                        : 'smw-tt-23'
                    "></td>
                  <td><= 23°C</td>
                </tr>
                <tr>
                  <td width="25" class="smw-tt-25"></td>
                  <td><= 25°C</td>
                </tr>
                <tr>
                  <td width="25" class="smw-tt-30"></td>
                  <td><= 30°C</td>
                </tr>
                <tr>
                  <td width="25" class="smw-tt-35"></td>
                  <td><= 35°C</td>
                </tr>
                <tr>
                  <td width="25" class="smw-tt-40"></td>
                  <td>> 35°C</td>
                </tr>
              </table>
            </div>

            <div style="display: inline-block; width: 50px"></div>

            <div style="display: inline-block">
              <h3>
                <fa-icon [icon]="['far', 'road']"></fa-icon>
                &nbsp; {{ 'PRODUCT.SMW.LEGENDE.road_condition' | translate }}
              </h3>

              <table cellpadding="3" class="legend-table">
                <tr>
                  <td width="25" class="cond-moist"></td>
                  <td>
                    {{ 'MAPPING.GMA_ROAD_CONDITION_SHORT.2' | translate }} =
                    {{ 'MAPPING.GMA_ROAD_CONDITION.2' | translate }}
                  </td>
                  <td width="25" class="cond-nass"></td>
                  <td>
                    {{ 'MAPPING.GMA_ROAD_CONDITION_SHORT.3' | translate }} =
                    {{ 'MAPPING.GMA_ROAD_CONDITION.3' | translate }}
                  </td>
                  <td width="25" class="table-danger"></td>
                  <td>
                    {{ 'MAPPING.GMA_ROAD_CONDITION_SHORT.29' | translate }} =
                    {{ 'MAPPING.GMA_ROAD_CONDITION.29' | translate }}
                  </td>
                </tr>
                <tr>
                  <td width="25" class="table-danger"></td>
                  <td>
                    {{ 'MAPPING.GMA_ROAD_CONDITION_SHORT.6' | translate }} =
                    {{ 'MAPPING.GMA_ROAD_CONDITION.6' | translate }}
                  </td>
                  <td width="25" class="table-danger"></td>
                  <td>
                    {{ 'MAPPING.GMA_ROAD_CONDITION_SHORT.10' | translate }} =
                    {{ 'MAPPING.GMA_ROAD_CONDITION.10' | translate }}
                  </td>
                  <td width="25" class="table-danger"></td>
                  <td>
                    {{ 'MAPPING.GMA_ROAD_CONDITION_SHORT.18' | translate }} =
                    {{ 'MAPPING.GMA_ROAD_CONDITION.18' | translate }}
                  </td>
                </tr>
                <tr>
                  <td width="25" class="table-danger"></td>
                  <td>
                    {{ 'MAPPING.GMA_ROAD_CONDITION_SHORT.8' | translate }} =
                    {{ 'MAPPING.GMA_ROAD_CONDITION.8' | translate }}
                  </td>
                  <td width="25" class="table-danger"></td>
                  <td>
                    {{ 'MAPPING.GMA_ROAD_CONDITION_SHORT.11' | translate }} =
                    {{ 'MAPPING.GMA_ROAD_CONDITION.11' | translate }}
                  </td>
                  <td width="25" class="table-danger"></td>
                  <td>
                    {{ 'MAPPING.GMA_ROAD_CONDITION_SHORT.16' | translate }} =
                    {{ 'MAPPING.GMA_ROAD_CONDITION.16' | translate }}
                  </td>
                </tr>
                <tr>
                  <td width="25" class="table-danger"></td>
                  <td>
                    {{ 'MAPPING.GMA_ROAD_CONDITION_SHORT.19' | translate }} =
                    {{ 'MAPPING.GMA_ROAD_CONDITION.19' | translate }}
                  </td>
                  <td width="25" class="table-danger"></td>
                  <td>
                    {{ 'MAPPING.GMA_ROAD_CONDITION_SHORT.26' | translate }} =
                    {{ 'MAPPING.GMA_ROAD_CONDITION.26' | translate }}
                  </td>
                  <td width="25" class="table-danger"></td>
                  <td>
                    {{ 'MAPPING.GMA_ROAD_CONDITION_SHORT.27' | translate }} =
                    {{ 'MAPPING.GMA_ROAD_CONDITION.27' | translate }}
                  </td>
                </tr>
              </table>
            </div>
          </mat-card-content>
        </mat-card>
      </ng-template>
    </form>
  </div>
  <!-- SIDENAV SETTINGS -->
  <div class="settings-button-stack">
    <!--legend button-->
    <button
      mat-mini-fab
      class="settings-button"
      (click)="onClickScroll('cardsLegend'); onClickStartAnimation()"
      tp="{{ 'PRODUCT.SMW.LEGENDE.TITLE' | translate }}"
      variation="popper"
      appendTo="parent"
      trigger="mouseenter"
      tpPlacement="left">
      <fa-icon [icon]="['far', 'info-circle']" size="lg"></fa-icon>
    </button>
    <button
      mat-mini-fab
      class="settings-button palette-toggle-button"
      [class.palette-toggle-button--active]="neutralColor() === 'green'"
      (click)="onToggleColor(neutralColor() !== 'green')"
      [matTooltip]="
        (neutralColor() === 'green'
          ? 'PRODUCT.EPP.SETTINGS.COLOR.GREEN'
          : 'PRODUCT.EPP.SETTINGS.COLOR.WHITE'
        ) | translate
      "
      tpPlacement="left">
      <fa-icon [icon]="['far', 'palette']" size="lg"></fa-icon>
    </button>
  </div>
</mat-drawer-container>
